import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import {useSelector} from "react-redux";
import { Action, Store } from "@byhuz/huz-ui-state";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views
import MapCodes from "views/admin/MapCodes.js";
import History from "views/admin/History.js";
import Transaction from "views/admin/Transaction.js";


export default function Admin() {

  const state=useSelector(state=>state.default);  

  React.useEffect(()=>{
    Store.dispatch(Action.update("passwordChanged", false));
  },[]);
  
  return (
    <>    
      
      <div className="relative bg-gray-200">
        <AdminNavbar/>
        {/* Header */}
        <div className="flex flex-wrap bg-blue-600 md:pt-10 pb-32 pt-1">
            <div className="w-full lg:w-12/12 md:w-full sm:w-full xl:w-3/3">
                <HeaderStats 
                    totalcredits={state?.user?.token?.toString()||0} 
                    totalspent={state?.user?.tokenspent?.toString()||0}
                    lastbuy={state?.user?.lasttokenbuy||""}
                    lastspent={state?.user?.lasttokenspent||""}
                    memstartdate={state?.user?.memstartdate||""}
                    memexpiredate={state?.user?.memexpiredate||""}
                    remainingmapcodes={state?.user?.remainingmapcodes?.toString()||0}
                    mapcodelastgen={state?.user?.mapcodelastgen||""}                    
                />              
            </div>
        </div>

        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/admin/history" exact component={History} />
            <Route path="/admin/transaction" exact component={Transaction} />
            <Route path="/admin/mapcodes" exact component={MapCodes} />
            <Redirect from="/admin" to="/admin/mapcodes" />
          </Switch>
          <FooterAdmin />
        </div>
      </div> 
    </>   
  );
}
